import { createModule } from 'saga-slice';
import { takeLatest, put } from 'redux-saga/effects';
import { sagaApi } from '#/apis';
import {
    failReducer, loadingReducer, readAllSuccess, noop
} from 'saga-slice-helpers';
import history from '#/history';

const sagaSlice = createModule({

    name: 'reports',
    initialState: {
        isFetching: false,
        data: {},
        error: null,
        measurements: null
    },

    reducers: {
        delinquencyReport: state => {
            state.isFetching = true;
            state.data = {};
        },
        delinquencyReportSuccess: readAllSuccess,
        delinquencyReportFail: failReducer,


        updateReportData: loadingReducer,
        updateReportDataSuccess: noop,
        updateReportDataFail: failReducer,

        createMeasurement: loadingReducer,
        createMeasurementSuccess: noop,
        createMeasurementFail: failReducer,


        deleteMeasurement: loadingReducer,
        deleteMeasurementSuccess: (state, payload) => {
        },


        fetchMeasurements: loadingReducer,
        fetchMeasurementsSuccess: (state, payload) => {
            state.isFetching = false;
            state.measurements = payload;
        },
        fetchMeasurementsFail: failReducer


    },

    sagas: A => ({

        [A.delinquencyReport]: {
            *saga({ payload: property_id }) {

                yield sagaApi.get(
                    `/properties/${property_id}/reports/delinquencies`,
                    A.delinquencyReportSuccess,
                    A.delinquencyReportFail
                );

                yield put(A.fetchMeasurements(property_id));
            },
            taker: takeLatest
        },
        [A.updateReportData]: {
            *saga({ payload }) {

                yield sagaApi.put(
                    `/report-data/${payload.id}`,
                    payload,
                    () => A.updateReportDataSuccess(payload.property_id),
                    A.updateReportDataFail
                );
            }
        },

        [A.updateReportDataSuccess]: function* ({ payload: property_id }) {
            yield history.push(`/properties/${property_id}/reports/delinquencies`);
        },
        [A.createMeasurement]: {
            *saga({ payload }) {

                yield sagaApi.post(
                    '/measurements',
                    payload,
                    A.createMeasurementSuccess,
                    A.createMeasurementFail
                );
            }
        },
        [A.fetchMeasurements]: {
            *saga({ payload: propertyId }) {

                yield sagaApi.get(
                    `/properties/${propertyId}/measurements`,
                    A.fetchMeasurementsSuccess,
                    A.fetchMeasurementsFail
                );
            }
        },
        [A.deleteMeasurement]: {
            *saga({ payload }) {
                const {
                    property_id, date
                } = payload;
                yield sagaApi.delete(
                    `/properties/${property_id}/measurements/${date}`,
                    null,
                    A.deleteMeasurementSuccess,
                    A.createMeasurementFail
                );
            }
        }

    })
});

// Export actions for convenience when importing from other modules
export const { actions } = sagaSlice;
export default sagaSlice;
